import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=4bd94494&scoped=true&"
import script from "./NewsDetail.vue?vue&type=script&lang=js&"
export * from "./NewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=4bd94494&scoped=true&lang=scss&"
import style1 from "./NewsDetail.vue?vue&type=style&index=1&id=4bd94494&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd94494",
  null
  
)

export default component.exports